var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('div',{staticClass:"loading-process"},[_c('div',{staticClass:"loading"}),_vm._v(" "),_c('div',{staticClass:"loading-text"},[_vm._v("loading")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }